/**
 * Espelha o valor (id) entre dois campos datalist do mesmo cliente.
 * Uso: em `#customer_id` → obs_sync_customer_peer('customer_nick')
 *      em `#customer_nick` → obs_sync_customer_peer('customer_id')
 *
 * - hookPeer adiado (peer pode não estar registrado ainda no pubsub).
 * - Limpar um campo NÃO apaga o outro (evita perder Cliente ao apagar Apelido para rebuscar).
 */
export default function (peerFieldName)
{
	const SHARED = { syncing: false };

	const normId = (v) =>
	{
		if (v == null || v === '' || v === -1 || v === '-1')
			return null;
		const n = Number(v);
		return Number.isFinite(n) && n >= 0 ? n : null;
	};

	return {

		_peer: peerFieldName,
		_peerHooked: false,

		captureEvents(_this = this)
		{
			queueMicrotask(() => this.ensurePeerHooked());
			this.safeProtoCall(_this);
		},

		ensurePeerHooked(attempt = 0)
		{
			if (this._peerHooked)
				return;
			const peer = this.locate(this._peer);
			if (!peer)
			{
				if (attempt < 20)
					setTimeout(() => this.ensurePeerHooked(attempt + 1), 0);
				else
					console.error(`obs_sync_customer_peer: peer não encontrado: ${this._peer}`);
				return;
			}
			peer.subscribe(['change'], this.onPeerChange.bind(this), false);
			this._peerHooked = true;
		},

		onPeerChange(_ev, _publisher, value)
		{
			if (SHARED.syncing)
				return;
			const next = normId(value);
			// Limpeza do peer: não espelhar (usuário pode estar limpando para buscar de novo)
			if (next == null)
				return;
			const cur = normId(this.getValue?.());
			if (cur === next)
				return;
			SHARED.syncing = true;
			try
			{
				this.setValue(next);
				this.refresh?.();
			}
			finally
			{
				SHARED.syncing = false;
			}
		},

	};
}
